import { Button } from '@mui/material';
import Iconify from 'src/components/iconify';

type Props = {
  onClick: any;
};
export default function ButtonAddToBasket({ onClick }: Props) {
  return (
    <Button
      fullWidth
      variant="outlined"
      startIcon={<Iconify icon="basil:shopping-basket-solid" />}
      onClick={onClick}
      sx={{
        typography: 'caption',
        fontWeight: 500,
        justifyContent: 'flex-start',
        border: '1px solid transparent',
      }}
      color="secondary"
    >
      Thêm vào giỏ
    </Button>
  );
}
